module.exports = __webpack_public_path__ + "img/liechtenstein.3b414129.svg";